/**
 * @generated SignedSource<<55d9c7b078e8a53fd9051aa3d4698a71>>
 * @relayHash a80f18f355fea50657cb9b7e4e285c1f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a80f18f355fea50657cb9b7e4e285c1f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type UserNameDisplayConfiguration = "HANDLE" | "NAME_AND_HANDLE" | "%future added value";
export type IssueViewerViewQuery$variables = {
  allowedOwner?: string | null | undefined;
  count?: number | null | undefined;
  hideTimeline?: boolean | null | undefined;
  number: number;
  owner: string;
  repo: string;
  skip?: number | null | undefined;
};
export type IssueViewerViewQuery$data = {
  readonly repository: Result<{
    readonly id: string;
    readonly isOwnerEnterpriseManaged: boolean | null | undefined;
    readonly issue: Result<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"IssueViewerIssue">;
    } | null | undefined, unknown>;
    readonly owner: {
      readonly userNameDisplayConfiguration: UserNameDisplayConfiguration;
    };
  } | null | undefined, unknown>;
  readonly safeViewer: {
    readonly " $fragmentSpreads": FragmentRefs<"IssueViewerViewer">;
  } | null | undefined;
};
export type IssueViewerViewQuery = {
  response: IssueViewerViewQuery$data;
  variables: IssueViewerViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "allowedOwner"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "hideTimeline"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "number"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "repo"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v7 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "repo"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "kind": "RequiredField",
  "field": (v8/*: any*/),
  "action": "THROW"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOwnerEnterpriseManaged",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userNameDisplayConfiguration",
  "storageKey": null
},
v12 = [
  {
    "kind": "Variable",
    "name": "number",
    "variableName": "number"
  }
],
v13 = {
  "kind": "Variable",
  "name": "allowedOwner",
  "variableName": "allowedOwner"
},
v14 = {
  "kind": "Variable",
  "name": "skip",
  "variableName": "skip"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v22 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v23 = [
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataType",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v26 = [
  (v8/*: any*/),
  (v17/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/)
],
v27 = {
  "kind": "InlineFragment",
  "selections": (v26/*: any*/),
  "type": "IssueFieldText",
  "abstractKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": (v26/*: any*/),
  "type": "IssueFieldSingleSelect",
  "abstractKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": (v26/*: any*/),
  "type": "IssueFieldMultiSelect",
  "abstractKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": (v26/*: any*/),
  "type": "IssueFieldDate",
  "abstractKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": (v26/*: any*/),
  "type": "IssueFieldNumber",
  "abstractKey": null
},
v32 = [
  (v8/*: any*/)
],
v33 = {
  "kind": "InlineFragment",
  "selections": (v32/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slashCommandsEnabled",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v43 = [
  (v15/*: any*/),
  (v19/*: any*/),
  (v8/*: any*/)
],
v44 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v43/*: any*/),
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v44/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v46 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v52 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isActor"
},
v53 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNode"
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileResourcePath",
  "storageKey": null
},
v55 = {
  "kind": "InlineFragment",
  "selections": [
    (v49/*: any*/),
    (v50/*: any*/),
    (v51/*: any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closed",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerDidAuthor",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locked",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileUrl",
  "storageKey": null
},
v60 = [
  (v17/*: any*/)
],
v61 = {
  "kind": "InlineFragment",
  "selections": (v60/*: any*/),
  "type": "User",
  "abstractKey": null
},
v62 = {
  "kind": "InlineFragment",
  "selections": (v60/*: any*/),
  "type": "EnterpriseUserAccount",
  "abstractKey": null
},
v63 = {
  "kind": "InlineFragment",
  "selections": (v60/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "unfurlReferences",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": "bodyHTML(unfurlReferences:true)"
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyVersion",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnpin",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanDelete",
  "storageKey": null
},
v71 = {
  "kind": "Literal",
  "name": "first",
  "value": 25
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionId",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "intentId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v19/*: any*/),
    (v64/*: any*/),
    (v8/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v51/*: any*/)
      ],
      "type": "Bot",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confidence",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rationale",
  "storageKey": null
},
v78 = [
  (v8/*: any*/),
  (v17/*: any*/),
  (v39/*: any*/)
],
v79 = [
  (v17/*: any*/),
  (v39/*: any*/),
  (v8/*: any*/)
],
v80 = [
  (v16/*: any*/),
  (v38/*: any*/),
  (v20/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Repository",
    "kind": "LinkedField",
    "name": "repository",
    "plural": false,
    "selections": [
      (v34/*: any*/),
      (v8/*: any*/)
    ],
    "storageKey": null
  }
],
v81 = [
  (v22/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASC",
      "field": "NAME"
    }
  }
],
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameHTML",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v84/*: any*/),
    (v85/*: any*/)
  ],
  "storageKey": null
},
v87 = [
  (v19/*: any*/)
],
v88 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReactionGroup",
      "kind": "LinkedField",
      "name": "reactionGroups",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerHasReacted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 5
            }
          ],
          "concreteType": "ReactorConnection",
          "kind": "LinkedField",
          "name": "reactors",
          "plural": false,
          "selections": [
            (v37/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v15/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v87/*: any*/),
                  "type": "User",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v19/*: any*/),
                    (v49/*: any*/),
                    (v50/*: any*/),
                    (v51/*: any*/)
                  ],
                  "type": "Bot",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v87/*: any*/),
                  "type": "Organization",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v87/*: any*/),
                  "type": "Mannequin",
                  "abstractKey": null
                },
                (v33/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "reactors(first:5)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Reactable",
  "abstractKey": "__isReactable"
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pendingBlock",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pendingUnblock",
  "storageKey": null
},
v91 = [
  {
    "kind": "Literal",
    "name": "allowSameEnterprise",
    "value": true
  },
  (v13/*: any*/),
  (v71/*: any*/)
],
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdate",
  "storageKey": null
},
v93 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "Status"
  }
],
v94 = {
  "alias": null,
  "args": (v91/*: any*/),
  "concreteType": "ProjectV2ItemConnection",
  "kind": "LinkedField",
  "name": "projectItems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2ItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectV2Item",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v18/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectV2",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v8/*: any*/),
                (v38/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "template",
                  "storageKey": null
                },
                (v92/*: any*/),
                (v20/*: any*/),
                {
                  "alias": null,
                  "args": (v93/*: any*/),
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "field",
                  "plural": false,
                  "selections": [
                    (v15/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v21/*: any*/),
                        (v8/*: any*/),
                        (v17/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProjectV2SingleSelectFieldOption",
                          "kind": "LinkedField",
                          "name": "options",
                          "plural": true,
                          "selections": [
                            (v8/*: any*/),
                            (v73/*: any*/),
                            (v17/*: any*/),
                            (v82/*: any*/),
                            (v39/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "descriptionHTML",
                              "storageKey": null
                            },
                            (v40/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "ProjectV2SingleSelectField",
                      "abstractKey": null
                    },
                    (v33/*: any*/)
                  ],
                  "storageKey": "field(name:\"Status\")"
                },
                (v56/*: any*/),
                (v16/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasReachedItemsLimit",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v93/*: any*/),
              "concreteType": null,
              "kind": "LinkedField",
              "name": "fieldValueByName",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v8/*: any*/),
                    (v73/*: any*/),
                    (v17/*: any*/),
                    (v82/*: any*/),
                    (v39/*: any*/)
                  ],
                  "type": "ProjectV2ItemFieldSingleSelectValue",
                  "abstractKey": null
                },
                (v33/*: any*/)
              ],
              "storageKey": "fieldValueByName(name:\"Status\")"
            },
            (v15/*: any*/)
          ],
          "storageKey": null
        },
        (v83/*: any*/)
      ],
      "storageKey": null
    },
    (v86/*: any*/)
  ],
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": (v91/*: any*/),
  "filters": [
    "allowedOwner",
    "allowSameEnterprise"
  ],
  "handle": "connection",
  "key": "ProjectSection_projectItems",
  "kind": "LinkedHandle",
  "name": "projectItems"
},
v96 = {
  "kind": "Literal",
  "name": "visibleEventsOnly",
  "value": true
},
v97 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v14/*: any*/),
  (v96/*: any*/)
],
v98 = [
  (v15/*: any*/),
  (v33/*: any*/)
],
v99 = {
  "alias": "issueTitleHTML",
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v17/*: any*/),
    (v35/*: any*/),
    (v44/*: any*/)
  ],
  "storageKey": null
},
v101 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v99/*: any*/),
    (v20/*: any*/),
    (v16/*: any*/),
    (v42/*: any*/),
    (v100/*: any*/)
  ],
  "type": "Issue",
  "abstractKey": null
},
v102 = {
  "alias": "pullTitleHTML",
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInMergeQueue",
  "storageKey": null
},
v104 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v102/*: any*/),
    (v20/*: any*/),
    (v16/*: any*/),
    (v41/*: any*/),
    (v47/*: any*/),
    (v103/*: any*/),
    (v100/*: any*/)
  ],
  "type": "PullRequest",
  "abstractKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v52/*: any*/),
    (v48/*: any*/),
    (v19/*: any*/),
    (v54/*: any*/),
    (v55/*: any*/),
    (v61/*: any*/),
    (v62/*: any*/),
    (v63/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v82/*: any*/),
    (v17/*: any*/),
    (v39/*: any*/),
    (v40/*: any*/)
  ],
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    (v77/*: any*/)
  ],
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v109 = [
  (v19/*: any*/),
  (v108/*: any*/),
  (v17/*: any*/)
],
v110 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v32/*: any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v32/*: any*/),
      "type": "Bot",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v32/*: any*/),
      "type": "Mannequin",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v32/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    (v33/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v19/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v109/*: any*/),
          "type": "User",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v109/*: any*/),
          "type": "Mannequin",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v19/*: any*/),
            (v108/*: any*/)
          ],
          "type": "Organization",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v19/*: any*/),
            (v108/*: any*/),
            (v49/*: any*/),
            (v51/*: any*/),
            (v50/*: any*/)
          ],
          "type": "Bot",
          "abstractKey": null
        }
      ],
      "type": "Actor",
      "abstractKey": "__isActor"
    }
  ],
  "storageKey": null
},
v111 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Milestone",
    "kind": "LinkedField",
    "name": "milestone",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      (v20/*: any*/)
    ],
    "storageKey": null
  },
  (v21/*: any*/),
  (v68/*: any*/),
  (v105/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "milestoneTitle",
    "storageKey": null
  }
],
v112 = [
  (v17/*: any*/),
  (v24/*: any*/)
],
v113 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v112/*: any*/),
      "type": "IssueFieldText",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v112/*: any*/),
      "type": "IssueFieldDate",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v112/*: any*/),
      "type": "IssueFieldNumber",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v112/*: any*/),
      "type": "IssueFieldSingleSelect",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v112/*: any*/),
      "type": "IssueFieldMultiSelect",
      "abstractKey": null
    },
    (v33/*: any*/)
  ],
  "storageKey": null
},
v114 = [
  (v17/*: any*/),
  (v39/*: any*/)
],
v115 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueComment",
    "kind": "LinkedField",
    "name": "issueComment",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/)
    ],
    "storageKey": null
  },
  (v21/*: any*/),
  (v68/*: any*/),
  (v105/*: any*/)
],
v116 = [
  (v68/*: any*/),
  (v21/*: any*/),
  (v105/*: any*/)
],
v117 = {
  "kind": "InlineFragment",
  "selections": [
    (v101/*: any*/),
    (v104/*: any*/)
  ],
  "type": "ReferencedSubject",
  "abstractKey": "__isReferencedSubject"
},
v118 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviatedOid",
  "storageKey": null
},
v119 = [
  (v21/*: any*/),
  (v68/*: any*/),
  (v105/*: any*/)
],
v120 = {
  "kind": "InlineFragment",
  "selections": [
    (v15/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v99/*: any*/),
        (v20/*: any*/),
        (v16/*: any*/),
        (v42/*: any*/),
        (v100/*: any*/)
      ],
      "type": "Issue",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v102/*: any*/),
        (v20/*: any*/),
        (v16/*: any*/),
        (v41/*: any*/),
        (v47/*: any*/),
        (v103/*: any*/),
        (v100/*: any*/)
      ],
      "type": "PullRequest",
      "abstractKey": null
    }
  ],
  "type": "ReferencedSubject",
  "abstractKey": "__isReferencedSubject"
},
v121 = [
  (v8/*: any*/),
  (v120/*: any*/)
],
v122 = [
  (v21/*: any*/),
  (v105/*: any*/),
  (v68/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockingIssue",
    "plural": false,
    "selections": (v121/*: any*/),
    "storageKey": null
  }
],
v123 = [
  (v21/*: any*/),
  (v105/*: any*/),
  (v68/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v121/*: any*/),
    "storageKey": null
  }
],
v124 = [
  (v21/*: any*/),
  (v8/*: any*/),
  (v120/*: any*/)
],
v125 = [
  (v21/*: any*/),
  (v105/*: any*/),
  (v68/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v124/*: any*/),
    "storageKey": null
  }
],
v126 = [
  (v21/*: any*/),
  (v105/*: any*/),
  (v68/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v124/*: any*/),
    "storageKey": null
  }
],
v127 = [
  (v21/*: any*/),
  (v105/*: any*/),
  (v68/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v15/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v38/*: any*/),
          (v20/*: any*/),
          (v16/*: any*/),
          (v41/*: any*/),
          (v47/*: any*/),
          (v103/*: any*/),
          (v45/*: any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      },
      (v33/*: any*/)
    ],
    "storageKey": null
  }
],
v128 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v99/*: any*/),
        (v20/*: any*/),
        (v42/*: any*/),
        (v100/*: any*/)
      ],
      "type": "Issue",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v102/*: any*/),
        (v20/*: any*/),
        (v41/*: any*/),
        (v47/*: any*/),
        (v103/*: any*/),
        (v100/*: any*/)
      ],
      "type": "PullRequest",
      "abstractKey": null
    }
  ],
  "type": "ReferencedSubject",
  "abstractKey": "__isReferencedSubject"
},
v129 = [
  (v8/*: any*/),
  (v16/*: any*/),
  (v128/*: any*/)
],
v130 = {
  "kind": "InlineFragment",
  "selections": (v129/*: any*/),
  "type": "Issue",
  "abstractKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanonicalOfClosedDuplicate",
  "storageKey": null
},
v132 = [
  (v117/*: any*/)
],
v133 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v20/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v134 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v79/*: any*/),
  "storageKey": null
},
v135 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueTimelineItemsEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v15/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isIssueTimelineItems"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v68/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "actor",
              "plural": false,
              "selections": (v43/*: any*/),
              "storageKey": null
            }
          ],
          "type": "TimelineEvent",
          "abstractKey": "__isTimelineEvent"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v57/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Issue",
              "kind": "LinkedField",
              "name": "issue",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": (v43/*: any*/),
                  "storageKey": null
                },
                (v8/*: any*/),
                (v16/*: any*/),
                (v58/*: any*/),
                (v21/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "author",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                (v19/*: any*/),
                (v64/*: any*/),
                (v59/*: any*/),
                (v8/*: any*/),
                (v61/*: any*/),
                (v62/*: any*/),
                (v63/*: any*/)
              ],
              "storageKey": null
            },
            (v8/*: any*/),
            (v65/*: any*/),
            (v66/*: any*/),
            (v67/*: any*/),
            (v92/*: any*/),
            (v20/*: any*/),
            (v68/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "authorAssociation",
              "storageKey": null
            },
            (v70/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanMinimize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanUnminimize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanReport",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanReportToMaintainer",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanBlockFromOrg",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanUnblockFromOrg",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanPin",
              "storageKey": null
            },
            (v69/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "App",
              "kind": "LinkedField",
              "name": "viaApp",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                (v20/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": "isHidden",
              "args": null,
              "kind": "ScalarField",
              "name": "isMinimized",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minimizedReason",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showSpammyBadge",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdViaEmail",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Sponsorship",
              "kind": "LinkedField",
              "name": "authorToRepoOwnerSponsorship",
              "plural": false,
              "selections": [
                (v68/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isActive",
                  "storageKey": null
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Repository",
              "kind": "LinkedField",
              "name": "repository",
              "plural": false,
              "selections": [
                (v8/*: any*/),
                (v17/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "owner",
                  "plural": false,
                  "selections": [
                    (v15/*: any*/),
                    (v8/*: any*/),
                    (v19/*: any*/),
                    (v20/*: any*/)
                  ],
                  "storageKey": null
                },
                (v35/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "viewerCanCreateIssues",
                  "storageKey": null
                },
                (v36/*: any*/),
                (v34/*: any*/),
                (v21/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanReadUserContentEdits",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastEditedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserContentEdit",
              "kind": "LinkedField",
              "name": "lastUserContentEdit",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "editor",
                  "plural": false,
                  "selections": [
                    (v15/*: any*/),
                    (v20/*: any*/),
                    (v19/*: any*/),
                    (v8/*: any*/)
                  ],
                  "storageKey": null
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "pinnedBy",
              "plural": false,
              "selections": [
                (v19/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pendingMinimizeReason",
                  "storageKey": null
                },
                (v89/*: any*/),
                (v90/*: any*/)
              ]
            },
            (v88/*: any*/)
          ],
          "type": "IssueComment",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "source",
              "plural": false,
              "selections": (v98/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "willCloseTarget",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "referencedAt",
              "storageKey": null
            },
            (v21/*: any*/),
            {
              "alias": "innerSource",
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "source",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                {
                  "kind": "TypeDiscriminator",
                  "abstractKey": "__isReferencedSubject"
                },
                (v101/*: any*/),
                (v104/*: any*/),
                (v33/*: any*/)
              ],
              "storageKey": null
            },
            (v105/*: any*/)
          ],
          "type": "CrossReferencedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v106/*: any*/),
            (v21/*: any*/),
            (v68/*: any*/),
            (v105/*: any*/),
            (v107/*: any*/)
          ],
          "type": "LabeledEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v106/*: any*/),
            (v21/*: any*/),
            (v68/*: any*/),
            (v105/*: any*/)
          ],
          "type": "UnlabeledEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v110/*: any*/),
            (v21/*: any*/),
            (v68/*: any*/),
            (v105/*: any*/),
            (v107/*: any*/)
          ],
          "type": "AssignedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v110/*: any*/),
            (v21/*: any*/),
            (v68/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "actor",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                (v19/*: any*/),
                (v52/*: any*/),
                (v48/*: any*/),
                (v54/*: any*/),
                (v55/*: any*/),
                (v61/*: any*/),
                (v62/*: any*/),
                (v63/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "UnassignedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v111/*: any*/),
          "type": "MilestonedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v111/*: any*/),
          "type": "DemilestonedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v113/*: any*/),
            (v21/*: any*/),
            (v105/*: any*/),
            (v68/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "IssueFieldTimelineOption",
              "kind": "LinkedField",
              "name": "options",
              "plural": true,
              "selections": (v114/*: any*/),
              "storageKey": null
            },
            (v72/*: any*/),
            (v39/*: any*/),
            (v107/*: any*/)
          ],
          "type": "IssueFieldAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v113/*: any*/),
            (v21/*: any*/),
            (v105/*: any*/),
            (v68/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IssueFieldTimelineOption",
              "kind": "LinkedField",
              "name": "newOptions",
              "plural": true,
              "selections": (v114/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newValue",
              "storageKey": null
            },
            (v107/*: any*/)
          ],
          "type": "IssueFieldChangedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v113/*: any*/),
            (v21/*: any*/),
            (v105/*: any*/),
            (v68/*: any*/),
            (v107/*: any*/)
          ],
          "type": "IssueFieldRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v115/*: any*/),
          "type": "IssueCommentPinnedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v115/*: any*/),
          "type": "IssueCommentUnpinnedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v116/*: any*/),
          "type": "SubscribedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v116/*: any*/),
          "type": "UnsubscribedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v116/*: any*/),
          "type": "MentionedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v68/*: any*/),
            (v42/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "duplicateOf",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                (v117/*: any*/),
                (v33/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "closingProjectItemStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "closer",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v20/*: any*/),
                    (v38/*: any*/)
                  ],
                  "type": "ProjectV2",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v20/*: any*/),
                    (v16/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Repository",
                      "kind": "LinkedField",
                      "name": "repository",
                      "plural": false,
                      "selections": [
                        (v8/*: any*/),
                        (v17/*: any*/),
                        (v44/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "PullRequest",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v20/*: any*/),
                    (v118/*: any*/),
                    (v45/*: any*/)
                  ],
                  "type": "Commit",
                  "abstractKey": null
                },
                (v33/*: any*/)
              ],
              "storageKey": null
            },
            (v105/*: any*/),
            (v107/*: any*/)
          ],
          "type": "ClosedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v119/*: any*/),
          "type": "ReopenedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v68/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockReason",
              "storageKey": null
            },
            (v105/*: any*/)
          ],
          "type": "LockedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v119/*: any*/),
          "type": "UnlockedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v119/*: any*/),
          "type": "PinnedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v119/*: any*/),
          "type": "UnpinnedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v68/*: any*/),
            (v105/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "previousTitle",
              "storageKey": null
            }
          ],
          "type": "RenamedTitleEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v122/*: any*/),
          "type": "BlockedByAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v122/*: any*/),
          "type": "BlockedByRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v123/*: any*/),
          "type": "BlockingAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v123/*: any*/),
          "type": "BlockingRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v68/*: any*/),
            (v105/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "deletedCommentAuthor",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                (v19/*: any*/),
                (v61/*: any*/),
                (v63/*: any*/),
                (v62/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "CommentDeletedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v68/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "blockDuration",
              "storageKey": null
            },
            (v105/*: any*/),
            {
              "alias": "blockedUser",
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "subject",
              "plural": false,
              "selections": [
                (v19/*: any*/),
                (v17/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "UserBlockedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v125/*: any*/),
          "type": "SubIssueAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v125/*: any*/),
          "type": "SubIssueRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v126/*: any*/),
          "type": "ParentIssueAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v126/*: any*/),
          "type": "ParentIssueRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*: any*/),
            (v21/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "willCloseSubject",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "subject",
              "plural": false,
              "selections": (v98/*: any*/),
              "storageKey": null
            },
            (v105/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Commit",
              "kind": "LinkedField",
              "name": "commit",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "message",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "messageHeadlineHTML",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "messageBodyHTML",
                  "storageKey": null
                },
                (v20/*: any*/),
                (v118/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Repository",
                  "kind": "LinkedField",
                  "name": "repository",
                  "plural": false,
                  "selections": [
                    (v17/*: any*/),
                    (v44/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "defaultBranch",
                      "storageKey": null
                    },
                    (v8/*: any*/)
                  ],
                  "storageKey": null
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            },
            (v68/*: any*/)
          ],
          "type": "ReferencedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v127/*: any*/),
          "type": "ConnectedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v105/*: any*/),
            (v68/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Repository",
              "kind": "LinkedField",
              "name": "fromRepository",
              "plural": false,
              "selections": [
                (v34/*: any*/),
                (v20/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "TransferredEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v127/*: any*/),
          "type": "DisconnectedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v105/*: any*/),
            (v68/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "duplicate",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                (v130/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v129/*: any*/),
                  "type": "PullRequest",
                  "abstractKey": null
                },
                (v33/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "canonical",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                (v130/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v16/*: any*/),
                    (v8/*: any*/),
                    (v128/*: any*/)
                  ],
                  "type": "PullRequest",
                  "abstractKey": null
                },
                (v33/*: any*/)
              ],
              "storageKey": null
            },
            (v131/*: any*/),
            (v21/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanUndo",
              "storageKey": null
            },
            (v8/*: any*/),
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pendingUndo",
                  "storageKey": null
                }
              ]
            }
          ],
          "type": "MarkedAsDuplicateEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v105/*: any*/),
            (v68/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "canonical",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v132/*: any*/),
                  "type": "Issue",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v132/*: any*/),
                  "type": "PullRequest",
                  "abstractKey": null
                },
                (v33/*: any*/)
              ],
              "storageKey": null
            },
            (v131/*: any*/),
            (v21/*: any*/)
          ],
          "type": "UnmarkedAsDuplicateEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v105/*: any*/),
            (v68/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Discussion",
              "kind": "LinkedField",
              "name": "discussion",
              "plural": false,
              "selections": [
                (v20/*: any*/),
                (v16/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "ConvertedToDiscussionEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v68/*: any*/),
            (v105/*: any*/),
            (v133/*: any*/)
          ],
          "type": "AddedToProjectV2Event",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v68/*: any*/),
            (v105/*: any*/),
            (v133/*: any*/)
          ],
          "type": "RemovedFromProjectV2Event",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v68/*: any*/),
            (v105/*: any*/),
            (v133/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "previousStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "type": "ProjectV2ItemStatusChangedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v68/*: any*/),
            (v105/*: any*/),
            (v21/*: any*/)
          ],
          "type": "ConvertedFromDraftEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v105/*: any*/),
            (v68/*: any*/),
            (v134/*: any*/),
            (v107/*: any*/)
          ],
          "type": "IssueTypeAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v105/*: any*/),
            (v68/*: any*/),
            (v134/*: any*/)
          ],
          "type": "IssueTypeRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v105/*: any*/),
            (v68/*: any*/),
            (v134/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "IssueType",
              "kind": "LinkedField",
              "name": "prevIssueType",
              "plural": false,
              "selections": (v79/*: any*/),
              "storageKey": null
            },
            (v107/*: any*/)
          ],
          "type": "IssueTypeChangedEvent",
          "abstractKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        },
        (v33/*: any*/)
      ],
      "storageKey": null
    },
    (v83/*: any*/)
  ],
  "storageKey": null
},
v136 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 0
  },
  (v96/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IssueViewerViewQuery",
    "selections": [
      {
        "kind": "CatchField",
        "field": {
          "alias": null,
          "args": (v7/*: any*/),
          "concreteType": "Repository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v10/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": [
                (v11/*: any*/)
              ],
              "storageKey": null
            },
            {
              "kind": "CatchField",
              "field": {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "args": [
                      (v13/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "count",
                        "variableName": "count"
                      },
                      {
                        "kind": "Variable",
                        "name": "hideTimeline",
                        "variableName": "hideTimeline"
                      },
                      (v14/*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "IssueViewerIssue"
                  }
                ],
                "storageKey": null
              },
              "to": "RESULT"
            }
          ],
          "storageKey": null
        },
        "to": "RESULT"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "safeViewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IssueViewerViewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "IssueViewerViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v11/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v12/*: any*/),
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanUpdateMetadata",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v19/*: any*/),
                      (v8/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "issueFieldsEnabled",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "name",
                                "value": "issue_fields"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "isFeatureEnabled",
                            "storageKey": "isFeatureEnabled(name:\"issue_fields\")"
                          },
                          {
                            "alias": null,
                            "args": (v23/*: any*/),
                            "concreteType": "IssueFieldsConnection",
                            "kind": "LinkedField",
                            "name": "pinnedIssueFields",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v15/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "pinnedIssueFields(first:100)"
                          }
                        ],
                        "type": "Organization",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v34/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isWritable",
                    "storageKey": null
                  },
                  (v35/*: any*/),
                  (v21/*: any*/),
                  (v36/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanPush",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanInteract",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerInteractionLimitReasonHTML",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCopilotAgentEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 3
                      }
                    ],
                    "concreteType": "PinnedIssueConnection",
                    "kind": "LinkedField",
                    "name": "pinnedIssues",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/)
                    ],
                    "storageKey": "pinnedIssues(first:3)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanPinIssues",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueCreationPermissions",
                    "kind": "LinkedField",
                    "name": "viewerIssueCreationPermissions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "triageable",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v23/*: any*/),
                    "concreteType": "IssueTypeConnection",
                    "kind": "LinkedField",
                    "name": "issueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v32/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "issueTypes(first:100)"
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              (v38/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "titleHTML",
                "storageKey": null
              },
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanUpdateNext",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v39/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isEnabled",
                    "storageKey": null
                  },
                  (v40/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedFields",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v33/*: any*/),
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SubIssuesSummary",
                "kind": "LinkedField",
                "name": "subIssuesSummary",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "completed",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v41/*: any*/),
              (v42/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "duplicateOf",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v20/*: any*/),
                  (v45/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "linkedPullRequests",
                "args": [
                  (v46/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "includeClosedPrs",
                    "value": false
                  },
                  {
                    "kind": "Literal",
                    "name": "orderByState",
                    "value": true
                  }
                ],
                "concreteType": "PullRequestConnection",
                "kind": "LinkedField",
                "name": "closedByPullRequestsReferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PullRequest",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Repository",
                        "kind": "LinkedField",
                        "name": "repository",
                        "plural": false,
                        "selections": [
                          (v34/*: any*/),
                          (v8/*: any*/),
                          (v17/*: any*/),
                          (v44/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v41/*: any*/),
                      (v47/*: any*/),
                      (v20/*: any*/),
                      (v16/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:false,orderByState:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentAssignment",
                "kind": "LinkedField",
                "name": "agentAssignments",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Bot",
                    "kind": "LinkedField",
                    "name": "assignee",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v19/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "assigner",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v52/*: any*/),
                      (v19/*: any*/),
                      (v8/*: any*/),
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v46/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "includeClosedPrs",
                    "value": true
                  }
                ],
                "concreteType": "PullRequestConnection",
                "kind": "LinkedField",
                "name": "closedByPullRequestsReferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PullRequest",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v16/*: any*/),
                      (v20/*: any*/),
                      (v41/*: any*/),
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:true)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 20
                  }
                ],
                "concreteType": "AssigneeConnection",
                "kind": "LinkedField",
                "name": "assignedActors",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          (v19/*: any*/),
                          (v17/*: any*/),
                          (v54/*: any*/),
                          (v48/*: any*/),
                          (v55/*: any*/)
                        ],
                        "type": "Actor",
                        "abstractKey": "__isActor"
                      },
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "assignedActors(first:20)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Milestone",
                "kind": "LinkedField",
                "name": "milestone",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v38/*: any*/),
                  (v56/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dueOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "progressPercentage",
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "closedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v21/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v52/*: any*/),
                  (v19/*: any*/),
                  (v8/*: any*/),
                  (v59/*: any*/),
                  (v61/*: any*/),
                  (v62/*: any*/),
                  (v63/*: any*/),
                  (v64/*: any*/),
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v49/*: any*/),
                      (v50/*: any*/)
                    ],
                    "type": "Bot",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v65/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PinnedIssueComment",
                "kind": "LinkedField",
                "name": "pinnedIssueComment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedBy",
                    "plural": false,
                    "selections": (v43/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueComment",
                    "kind": "LinkedField",
                    "name": "issueComment",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 700
                          },
                          {
                            "kind": "Literal",
                            "name": "stripBlockElements",
                            "value": false
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "shortBodyHTML",
                        "storageKey": "shortBodyHTML(limit:700,stripBlockElements:false)"
                      },
                      (v68/*: any*/),
                      (v20/*: any*/),
                      (v69/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v19/*: any*/),
                          (v64/*: any*/),
                          (v59/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanComment",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanAssign",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanSetMilestone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPinned",
                "storageKey": null
              },
              (v70/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanTransfer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanConvertToDiscussion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanLock",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanSetFields",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v71/*: any*/)
                ],
                "concreteType": "IssueFieldValueConnection",
                "kind": "LinkedField",
                "name": "issueFieldValues",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v27/*: any*/),
                              (v33/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v72/*: any*/)
                        ],
                        "type": "IssueFieldTextValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v28/*: any*/),
                              (v33/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v73/*: any*/),
                          (v17/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/)
                        ],
                        "type": "IssueFieldSingleSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v29/*: any*/),
                              (v33/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IssueFieldSingleSelectOption",
                            "kind": "LinkedField",
                            "name": "options",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              (v17/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "multiSelectValue",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "IssueFieldMultiSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v30/*: any*/),
                              (v33/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v72/*: any*/)
                        ],
                        "type": "IssueFieldDateValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v31/*: any*/),
                              (v33/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "numberValue",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "IssueFieldNumberValue",
                        "abstractKey": null
                      },
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "issueFieldValues(first:25)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "pendingSuggestions",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "typeState",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      (v74/*: any*/),
                      (v75/*: any*/),
                      (v76/*: any*/),
                      (v77/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": (v78/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "PendingTypeSuggestion",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "labelState",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      (v74/*: any*/),
                      (v75/*: any*/),
                      (v76/*: any*/),
                      (v77/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "label",
                        "plural": false,
                        "selections": (v78/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "PendingLabelSuggestion",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "fieldState",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      (v74/*: any*/),
                      (v75/*: any*/),
                      (v77/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "suggestedValue",
                        "storageKey": null
                      },
                      (v76/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "issueField",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v33/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v60/*: any*/),
                            "type": "IssueFieldCommon",
                            "abstractKey": "__isIssueFieldCommon"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueFieldSingleSelectOption",
                                "kind": "LinkedField",
                                "name": "options",
                                "plural": true,
                                "selections": (v79/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "IssueFieldSingleSelect",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PendingFieldSuggestion",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "closeState",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      (v74/*: any*/),
                      (v75/*: any*/),
                      (v77/*: any*/),
                      (v76/*: any*/),
                      (v42/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "duplicateOf",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v80/*: any*/),
                            "type": "Issue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v80/*: any*/),
                            "type": "PullRequest",
                            "abstractKey": null
                          },
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PendingCloseSuggestion",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "assigneeState",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      (v74/*: any*/),
                      (v75/*: any*/),
                      (v76/*: any*/),
                      (v77/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "assignee",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v33/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v19/*: any*/),
                              (v51/*: any*/),
                              (v64/*: any*/)
                            ],
                            "type": "Actor",
                            "abstractKey": "__isActor"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v50/*: any*/)
                            ],
                            "type": "Bot",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PendingAssigneeSuggestion",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v81/*: any*/),
                    "concreteType": "LabelConnection",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v39/*: any*/),
                              (v17/*: any*/),
                              (v82/*: any*/),
                              (v40/*: any*/),
                              (v20/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v83/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v86/*: any*/)
                    ],
                    "storageKey": "labels(first:100,orderBy:{\"direction\":\"ASC\",\"field\":\"NAME\"})"
                  },
                  {
                    "alias": null,
                    "args": (v81/*: any*/),
                    "filters": [
                      "orderBy"
                    ],
                    "handle": "connection",
                    "key": "MetadataSectionAssignedLabels_labels",
                    "kind": "LinkedHandle",
                    "name": "labels"
                  },
                  (v53/*: any*/)
                ],
                "type": "Labelable",
                "abstractKey": "__isLabelable"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v68/*: any*/)
                ],
                "type": "Comment",
                "abstractKey": "__isComment"
              },
              (v88/*: any*/),
              {
                "kind": "ClientExtension",
                "selections": [
                  (v89/*: any*/),
                  (v90/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v94/*: any*/),
                      (v95/*: any*/)
                    ],
                    "type": "Issue",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v94/*: any*/),
                      (v95/*: any*/),
                      (v92/*: any*/)
                    ],
                    "type": "PullRequest",
                    "abstractKey": null
                  }
                ],
                "type": "IssueOrPullRequest",
                "abstractKey": "__isIssueOrPullRequest"
              },
              {
                "condition": "hideTimeline",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "alias": "frontTimelineItems",
                    "args": (v97/*: any*/),
                    "concreteType": "IssueTimelineItemsConnection",
                    "kind": "LinkedField",
                    "name": "timelineItems",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          (v85/*: any*/),
                          (v84/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v37/*: any*/),
                      (v135/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "frontTimelineItems",
                    "args": (v97/*: any*/),
                    "filters": [
                      "visibleEventsOnly",
                      "skip"
                    ],
                    "handle": "connection",
                    "key": "Issue__frontTimelineItems",
                    "kind": "LinkedHandle",
                    "name": "timelineItems"
                  },
                  {
                    "alias": "backTimelineItems",
                    "args": (v136/*: any*/),
                    "concreteType": "IssueTimelineItemsConnection",
                    "kind": "LinkedField",
                    "name": "timelineItems",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPreviousPage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startCursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v37/*: any*/),
                      (v135/*: any*/)
                    ],
                    "storageKey": "timelineItems(last:0,visibleEventsOnly:true)"
                  },
                  {
                    "alias": "backTimelineItems",
                    "args": (v136/*: any*/),
                    "filters": [
                      "visibleEventsOnly"
                    ],
                    "handle": "connection",
                    "key": "Issue__backTimelineItems",
                    "kind": "LinkedHandle",
                    "name": "timelineItems"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "safeViewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnterpriseManagedUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enterpriseManagedEnterpriseId",
            "storageKey": null
          },
          (v19/*: any*/),
          (v8/*: any*/),
          (v17/*: any*/),
          (v48/*: any*/),
          (v15/*: any*/),
          (v54/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "a80f18f355fea50657cb9b7e4e285c1f",
    "metadata": {},
    "name": "IssueViewerViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5f07b123550fd5678b092810f2fa1f52";

export default node;
